import React, { useMemo } from 'react';
import moment from 'moment';
import useSpaceSuggestions from '../../../api/suggestions';

export default function SpaceSuggestions({ spaceId, t }) {
    const { data, isLoading, isError, error, refetch, isFetching, dataUpdatedAt } =
        useSpaceSuggestions({ spaceId });

    const lastUpdated = useMemo(() => {
        return dataUpdatedAt ? moment(new Date(dataUpdatedAt)).fromNow() : t?.('never') || 'never';
    }, [dataUpdatedAt, t]);

    if (!spaceId) return null;

    return (
        <div className="admin-suggestions-list form-group-block mt-4">
            <div className="form-group-title d-flex align-items-center gap-2">
                <span>{t ? t('Suggestions') : 'Suggestions'}</span>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm ms-auto"
                    onClick={() => refetch()}
                    disabled={isFetching}
                    title={t ? t('Refresh') : 'Refresh'}
                >
                    {isFetching ? <span className="spinner-border spinner-border-sm" /> : (t ? t('Refresh') : 'Refresh')}
                </button>
                <span className="text-muted small">
          {(t ? t('Last updated') : 'Last updated')}: {lastUpdated}
        </span>
            </div>

            {isLoading ? (
                <div className="p-3 text-muted">{t ? t('Loading...') : 'Loading...'}</div>
            ) : isError ? (
                <div className="alert alert-danger my-2">
                    {error?.message || (t ? t('Failed to load suggestions') : 'Failed to load suggestions')}
                </div>
            ) : !data?.data?.length ? (
                <div className="p-3 text-muted">{t ? t('No suggestions yet') : 'No suggestions yet'}</div>
            ) : (
                <div className="suggestions-thread">
                    {/* simple chat-like stack */}
                    {data.data.map((s) => (
                        <div key={s._id} className="suggestion-bubble mb-2 p-2 rounded bg-white border">
                            <div className="d-flex justify-content-between small text-muted mb-1">
                                <strong>{s.contact || 'anonymous'}</strong>
                                <span>{moment(s.createdAt).format('lll')}</span>
                            </div>
                            <div className="suggestion-text">{s.suggestion}</div>
                            {s.confirmed && (
                                <div className="mt-1 small text-success">
                                    {t ? t('Confirmed') : 'Confirmed'}
                                    {s.confirmedAt ? ` • ${moment(s.confirmedAt).fromNow()}` : ''}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
